<div style="display: flex; flex-direction: column; gap: 5px">
	<mat-list>
		@for (log of logs; track log) {
			<mat-list style="display: flex; flex-direction: row; gap: 10px; justify-content: flex-start; align-items: center; flex-wrap: wrap">
				<button *ngIf="bookingId" mat-icon-button color="warn" (click)="deleteLog(log?.id)"><mat-icon>delete</mat-icon></button>
				<button *ngIf="flightId" mat-icon-button color="warn" (click)="deleteLog(log?.id, log?.booking?.id)">
					<mat-icon>delete</mat-icon>
				</button>
				<div style="min-width: 140px; display: flex; flex-direction: column">
					<div style="display: flex; flex-direction: row; gap: 10px; justify-content: flex-start; align-items: end">
						{{ log?.date | formatDate: 'YYYY-MM-DD HH:mm' }}
						<button mat-icon-button disabled="true"><mat-icon *ngIf="log.merge">merge</mat-icon></button>
					</div>
					<div style="font-size: small">{{ log?.user }}</div>
				</div>
				<button
					*ngIf="bookingId && log?.flight?.id"
					mat-stroked-button
					[disabled]="log?.flight?.removed"
					(click)="navigateToFlight(log?.flight.id)"
					style="min-width: 280px; word-wrap: break-word; display: flex; justify-content: flex-start; align-items: center"
				>
					<mat-icon *ngIf="log.reason === 'TRANSFER'">swap_horiz</mat-icon>
					<mat-icon class="mat-accent-icon" *ngIf="log.reason !== 'TRANSFER' && log.action === 'INVI'">sms</mat-icon>
					<mat-icon class="mat-accent-icon" *ngIf="log.reason !== 'TRANSFER' && log.action === 'ADDE'">assignment</mat-icon>
					<mat-icon class="mat-accent-icon" *ngIf="log.reason !== 'TRANSFER' && log.action === 'CONF'">assignment_turned_in</mat-icon>
					<mat-icon *ngIf="log.reason !== 'TRANSFER' && log.action === 'REMO'">delete</mat-icon>
					{{ log?.flight?.balloon?.name }} {{ log?.flight?.hour | formatDate: 'DD MMM YY' }}
				</button>
				<div
					*ngIf="bookingId && !log?.flight?.id"
					style="min-width: 280px; word-wrap: break-word; display: flex; justify-content: flex-start; align-items: center"
				>
					{{ 'BOOKINGS.no_flight_added' | translate | capitalize }}
				</div>
				<button
					*ngIf="flightId"
					mat-stroked-button
					(click)="navigateToBooking(log?.booking.id)"
					style="min-width: 280px; word-wrap: break-word; display: flex; justify-content: flex-start; align-items: center"
				>
					<mat-icon *ngIf="log.reason === 'TRANSFER'">swap_horiz</mat-icon>
					<mat-icon class="mat-accent-icon" *ngIf="log.reason !== 'TRANSFER' && log.action === 'INVI'">sms</mat-icon>
					<mat-icon class="mat-accent-icon" *ngIf="log.reason !== 'TRANSFER' && log.action === 'ADDE'">assignment</mat-icon>
					<mat-icon class="mat-accent-icon" *ngIf="log.reason !== 'TRANSFER' && log.action === 'CONF'">assignment_turned_in</mat-icon>
					<mat-icon *ngIf="log.reason !== 'TRANSFER' && log.action === 'REMO'">delete</mat-icon>
					{{ log?.booking?.contactName }}
				</button>
				<div style="display: flex; flex-direction: column; min-width: 180px">
					<div>{{ log.reason === 'TRANSFER' ? ('BOOKINGS.LOG.TRANSFER' | translate | capitalize) : ('BOOKINGS.LOG.' + log.action | translate | capitalize) }}</div>
					<div style="font-size: small" *ngIf="log.reason && log.reason !== 'TRANSFER'">{{ log.reason }}</div>
				</div>
			</mat-list>
			<mat-divider></mat-divider>
		}
	</mat-list>
</div>
